import { Bitmap, Event, MovieClip } from "../runtime";
import { G_arrow } from "./assets";

/**
 * One of the two "< >" nudge arrows beside a menu option's value. `press`
 * kicks it 10px outwards, then an enterFrame listener walks it back 2px per
 * frame to its resting position and detaches itself.
 */
export class Arrow extends MovieClip {
  private readonly initialPos: number;

  constructor(dir = 0, dist = 0, txtWidth = 0, y = 0) {
    super();
    const bitArrow = new Bitmap(new G_arrow());
    bitArrow.x = bitArrow.width * -0.5;
    bitArrow.y = bitArrow.height * -0.5;
    if (dir === 0) {
      this.scaleX = -1;
    }
    this.x += dist * this.scaleX + txtWidth * 0.5;
    this.y = y;
    this.initialPos = this.x | 0;
    this.addChild(bitArrow);
  }

  press(): void {
    this.x += this.scaleX * 10;
    this.addEventListener(Event.ENTER_FRAME, this.update);
  }

  private update = (_e: Event): void => {
    if (this.x > this.initialPos) {
      this.x -= 2;
    }
    if (this.x < this.initialPos) {
      this.x += 2;
    }
    if (this.x === this.initialPos) {
      this.removeEventListener(Event.ENTER_FRAME, this.update);
    }
  };
}
